import { truncateSelectedValues, formatSelectionsArray } from "./utils";
import { featuresData } from "@cinch-nx/data-search";
export const getFormattedFeatures = (featureSelections)=>truncateSelectedValues(formatSelectionsArray(featureSelections, featuresData), 4, "and");
